import React, { useState, useEffect, useRef } from 'react';

function CustomSelect(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [curVal, setCurVal] = useState('');
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Converte os dados para formato padrão
  const options = Array.isArray(props.data) 
    ? props.data 
    : Object.entries(props.data || {}).map(([value, label]) => ({ label, value }));

  // Atualiza o valor inicial
  useEffect(() => {
    const initialOption = options.find(opt => String(opt.value) === String(props.value));
    setCurVal(initialOption?.label || props.label || '');
  }, [props.value, options, props.label]);

  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && 
          dropdownRef.current && 
          buttonRef.current &&
          !dropdownRef.current.contains(event.target) &&
          !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setSearchTerm('');
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSelect = (value, label) => {
    setCurVal(label);
    props.onChange({ target: { name: props.name, value } });
    
    if (!props.search) {
      setIsOpen(false);
    } else {
      setSearchTerm('');
    }
  };

  // Filtra as opções
  const filteredOptions = options.filter(option => 
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='relative z-50' ref={buttonRef}>
      <button
        type='button'
        className={`px-2 py-1 w-full rounded border border-gray-300 focus:outline-none min-w-[200px] bg-white ${
          isOpen ? 'border-blue-500 ring-1  ring-blue-500' : ''
        }`}
        onClick={toggleDropdown}
      >
        {curVal || props.label}
      </button>
      
      {isOpen && (
        <div 
          className='absolute top-full left-0 w-full min-w-[200px] bg-white border border-gray-300 shadow-lg max-h-[300px] overflow-x-hidden overflow-y-auto z-10'
          ref={dropdownRef}
        >
          {props.search && (
            <input
              type='text'
              placeholder='Pesquisar'
              className='px-4 py-2 border-b border-gray-300 focus:outline-none sticky top-0 w-full'
              value={searchTerm}
              onChange={handleSearch}
              autoFocus
            />
          )}

          <ul>
            {filteredOptions.map(option => (
              <li
                key={option.value}
                className='px-2 py-2 hover:bg-gray-100 cursor-pointer'
                onClick={() => handleSelect(option.value, option.label)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default CustomSelect;